import PropTypes from "prop-types";
import { isRecipeDetailsType } from "../utils/recipe-details";

export const RecipeTypeLabel = ({ foodType, recipeId }) => {
  if (!foodType) return null;

  if (!isRecipeDetailsType(foodType) || !recipeId) {
    return <span className="subtitle capitalize">{foodType}</span>;
  }

  const href = `/actions/refresh?modal[type]=recipe-detail&recipeType=${encodeURIComponent(foodType)}&recipeId=${encodeURIComponent(recipeId)}`;

  return (
    <a href={href} className="subtitle capitalize recipe-detail-trigger">
      {foodType}
    </a>
  );
};

RecipeTypeLabel.propTypes = {
  foodType: PropTypes.string,
  recipeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
